import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';
import Company from '../../app/models/Company';
import User from '../../app/models/User';

// used to separate jobsite code from the mainstore / authenticationstore
export const useCommonStore = defineStore('common', {
    state: () => ({
        locale: null,
        currentUserId: null,
        currentCompanyId: null,
        availableLanguages: null,
        companyRepo: useRepo(Company),
        userRepo: useRepo(User),
    }),
    getters: {
        currentCompany(state) {
            return state.currentCompanyId
                ? state.companyRepo
                    .with('jobsite')
                    .find(state.currentCompanyId)
                : null;
        },
        currentUser(state) {
            return state.currentUserId
                ? state.userRepo
                    .with('companies')
                    .with('companyUsers')
                    .find(state.currentUserId)
                : null;
        },
    },
    actions: {
        setLocale(locale) {
            this.locale = locale;
        },
        setAvailableLanguages(lang) {
            this.availableLanguages = lang;
        },
        setCurrentUserId(userId) {
            this.currentUserId = userId;
        },
        setCurrentCompanyId(companyId) {
            this.currentCompanyId = companyId;
        },
        resetState() {
            this.$reset();
        }
    }
})
